export default "__VITE_ASSET__BmvLhdBi__"